// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"ddf973798c25c6a53609","452":"0dc1492ad851e35ff0fd","522":"d65956d508c2d99ee9e9","551":"95e28e8cfab75e36460b"}[chunkId] + ".js";
};